import { render, staticRenderFns } from "./PressRelease.vue?vue&type=template&id=e389ceb2&scoped=true&"
import script from "./PressRelease.vue?vue&type=script&lang=js&"
export * from "./PressRelease.vue?vue&type=script&lang=js&"
import style0 from "./PressRelease.vue?vue&type=style&index=0&id=e389ceb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e389ceb2",
  null
  
)

export default component.exports